<template>
  <div class="tw-flex tw-justify-center tw-items-center">
    <span>{{
      getComponentUiText("app-settings-evidence-modal-uploading-1")
    }}</span
    ><span class="tw-w-[2px]">{{ loadingText }}</span>
  </div>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";
import { ref, onMounted, onUnmounted } from "vue";

const loadingText = ref("");
const loadingStates = ["", ".", "..", "..."];
let index = 0;
let interval;

onMounted(() => {
  interval = setInterval(() => {
    loadingText.value = loadingStates[index];
    index = (index + 1) % loadingStates.length;
  }, 300);
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>
<style lang="scss" scoped>
span {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  line-height: 135%;
  color: #878787;
  font-family: "Poppins";
}
</style>
